/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_EmailInputs */

const en_samples_email = /** @type {(inputs: Samples_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const es_samples_email = /** @type {(inputs: Samples_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electronico`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Samples_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_email = /** @type {((inputs?: Samples_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_email(inputs)
	return es_samples_email(inputs)
});